import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热度榜单', href: '#ranking' },
  { label: '精选专题', href: '#carousel' },
  { label: '热门推荐', href: '#cards' },
  { label: '平台优势', href: '#features' },
  { label: '关于糖心', href: '#about' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2.5 cursor-pointer group"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide group-hover:text-primary-600 transition-colors">
              糖心影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-3.5 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 border border-background-300/60 rounded-lg hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer"
            >
              投稿合作
            </a>
            <a
              href="#app"
              onClick={(e) => handleNavClick(e, '#app')}
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即观影
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <div className="flex gap-3 mt-2 pt-3 border-t border-background-200/70">
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="flex-1 px-4 py-2.5 text-sm font-medium text-center text-foreground-700 border border-background-300/60 rounded-lg hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer"
              >
                投稿合作
              </a>
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="flex-1 px-4 py-2.5 text-sm font-semibold text-center bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                立即观影
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}